import {mapGetters} from 'vuex';
import Vue from 'vue';
import {App} from './components'
import router from './router'
import store from './store'
import './plugins';
import vuetify from './plugins/vuetify'
import {i18n} from './plugins'
import './layouts';
import bugsnagService from './services/bugsnagService';
import visibilityService from './services/visibilityService';
import salesforceService from '../../ml/services/salesforceService';
import DOMPurify from 'dompurify';

Vue.config.productionTip = false;

store.dispatch('initStore')
  .then(() => {
    const app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App),
      computed: {
        ...mapGetters('content', [
          'theme',
        ]),
        appBarColor() {
          if (this.theme && this.theme.header_bg) {
            return this.theme.header_bg;
          }
          return 'primary';
        },
        appBarDark() {
          if (this.theme) {
            return this.theme.content_library_dark_variant;
          }
          return true;
        },
        appBarStyle() {
          if (this.appBarColor === 'primary') {
            return `background-color: ${this.$vuetify.theme.themes.light.primary}`; // MLD-2660
          }
          return `background-color: ${this.appBarColor}`;
        },
        folderTreeViewColor() {
          /*if (this.theme && this.theme.header_tint) {
            return this.theme.header_tint;
          }
          return 'primary';*/
          return '#000000'; // MLD-3089
        },
        appBarLogo() {
          if (this.theme && this.theme.image_url) {
            return this.theme.image_url;
          }
          return '/v2/images/mobilelocker_logo_white.png';
        },
        isAdminRoute() {
          return this.$route.path.includes('admin')
        },
        isLibraryRoute() {
          return this.$route.name.includes('library.')
        },
        isMobileRoute() { // MLD-3922
          return this.$route.name.includes('mobile.');
        },
        routePrefix() { // MLD-3922
          if (this.isLibraryRoute) {
            return 'library';
          } else if (this.isMobileRoute) {
            return 'mobile';
          } else {
            return 'admin';
          }
        },
        appOrLibrary() {
          if (this.isLibraryRoute) {
            return 'library';
          }
          return 'app';
        },
        isMobile() { // @see https://vuetifyjs.com/en/features/breakpoints/#usage
          return this.$vuetify.breakpoint.mobile;
        },
        isSalesforce() {
          return this.crmProvider === 'salesforce';
        },
        crmProvider() { // MLD-6667
          return this.$route.query.crm_provider ?? null;
        },
        crmObject() {
          return this.$route.query.crm_object ?? null;
        },
        crmObjectID() {
          return this.$route.query.crm_object_id ?? null;
        },
        hasCRMObject() {
          return this.crmProvider
            && this.crmObject
            && this.crmObjectID;
        },
      },
      async mounted() {
        // MLD-6145
        await this.$store.dispatch('refreshTokenPeriodically');
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        //console.log('Breakpoint', this.$vuetify.breakpoint.name, this.$vuetify.breakpoint.width)

      },
      beforeDestroy() {
        // MLD-6145
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
      },
      created() {
        this.fetchData().then();
      },
      methods: {
        // MLD-6145
        async handleVisibilityChange() {
          if (visibilityService.isTabVisible()) {
            await this.$store.dispatch('refreshToken');
          }
        },
        async fetchData() {
          await this.fetchCustomer();
        },
        async fetchCustomer() {
          if (this.hasCRMObject) { // MLD-6667
            if (this.isSalesforce) {
              try {
                const sfObject = await salesforceService.getObject(this.crmObject, this.crmObjectID);
                await this.$store.dispatch('content/setSelectedCustomers', [sfObject]);
                const message = DOMPurify.sanitize(`Customer ${sfObject.name} selected.`);
                this.$toast.success(message);
                await this.$router.replace({name: `${this.$root.routePrefix}.home`});
              } catch (e) {
              }
            }
          }
        }
      }
    });

    window.app = app;
    app.$mount('#app');
  })
  .catch(err => {
    bugsnagService.notify(new Error('v2 initStore failed with uncaught exception')); // MLD-5144
  });
